import BillingStore from '../../stores/BillingStore';
import Settings from '../../utils/Settings';
import { loadSubscriptionInformation } from '../../apps/Billing/actions/BillingActionCreators';

async function requireSubscription(nextState) {
  if (Settings.envFeatures.get('bigBank')) {
    return {};
  } else {

    console.info('Checking for active subscription');
    const context = nextState.routes[0].getContext();
    const billingStore = context.getStore(BillingStore);
    await context.executeAction(loadSubscriptionInformation, {});

    const toReturn = {};
    if (!billingStore.isCurrentSubscriptionActive()) {
      const newLocation = {
        pathname: '/billing/subscriptions'
      };
      console.info('No active subscription found for current client.  Redirecting to subscriptions page', {
        newLocation,
        nextState
      });
      toReturn.redirect = newLocation;
    }

    return toReturn;

  }
}

export default requireSubscription;



// WEBPACK FOOTER //
// ./src/utils/route/requireSubscription.js